/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import type Maybe from 'graphql/tsutils/Maybe';

import type { Theme } from '@coursera/cds-core';
import { Typography2, breakpoints } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

type Props = {
  items?: Array<Maybe<string>>;
  style?: SerializedStyles | ((theme: Theme) => SerializedStyles);
};

const styles = {
  howDetailsCollection: () => css`
    list-style-type: none;
    padding-inline-start: 0;
    width: 100%;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    li {
      text-align: start;
      display: flex;
      align-items: center;
      flex-direction: row;
      width: 100%;
      flex-wrap: nowrap;
      margin-bottom: var(--cds-spacing-150);

      span {
        display: flex;
        font-size: 14px;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: -0.28px;
      }

      :last-child {
        margin-bottom: 0;
      }

      ${breakpoints.down('xs')} {
        line-height: 140% !important;
        letter-spacing: -0.02em;
      }

      svg {
        align-items: center;
        margin-inline-end: var(--cds-spacing-100);
        color: var(--cds-color-blue-700);
        flex-shrink: 0;
      }
    }
  `,
};

export const BenefitList = ({ items = [], style }: Props) => {
  if (items?.length < 1) {
    return null;
  }

  return (
    <ul css={[styles.howDetailsCollection, style]}>
      {items?.map((item) =>
        item ? (
          <li key={item}>
            <CheckIcon size="large" color="interactive" />
            <Typography2 variant="bodyPrimary" component="span">
              {item}
            </Typography2>
          </li>
        ) : null
      )}
    </ul>
  );
};

export default React.memo(BenefitList);
